var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 0.218506C23.1634 0.218506 29.7813 6.83643 29.7813 15C29.7813 23.1637 23.1634 29.7816 14.9998 29.7816C6.83618 29.7816 0.218262 23.1637 0.218262 15C0.218262 6.83643 6.83618 0.218506 14.9998 0.218506ZM10.9177 12.5221H7.85319V22.3908H10.9177V12.5221ZM18.7189 12.2746C17.2279 12.2746 16.2285 13.0929 15.8194 13.8683H15.7765V12.5221H12.8373V22.3908H15.8986V17.5043C15.8986 16.2175 16.1427 14.9736 17.736 14.9736C19.3062 14.9736 19.3293 16.4419 19.3293 17.5868V22.3908H22.3906V16.9698C22.3906 14.317 21.8204 12.2746 18.7189 12.2746ZM9.38381 7.60965C8.40363 7.60965 7.60903 8.40424 7.60903 9.38443C7.60903 10.3644 8.40387 11.176 9.38381 11.176C10.3634 11.176 11.1586 10.3644 11.1586 9.38443C11.1586 8.40424 10.364 7.60965 9.38381 7.60965Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5658349144a4b8a5c934d70a7d614db6.svg";
export { ForwardRef as ReactComponent };